export default "__VITE_ASSET__BaTeZ$bg__"